import { createMuiTheme } from '@material-ui/core/styles';
import * as colours from 'colours';
import { NEVADA_GRAY } from 'colours';

// https://material-ui.com/customization/default-theme/
const zcareTheme = createMuiTheme({
  // https://material-ui.com/customization/typography/
  typography: {
    // Tell Material-UI what's the font-size on the html element is.
    // https://material-ui.com/customization/typography/#html-font-size
    // htmlFontSize: 10,
    fontFamily: '"Museo", "MuseoSans, "MuseoSans-500"',
    h1: {
      fontFamily: 'MuseoSans-900',
      fontSize: 38,
      lineHeight: 1.05,
      fontStretch: 'normal',
      fontStyle: 'normal',
      textAlign: 'left',
    },
    h2: {
      fontFamily: 'MuseoSans-500',
      fontSize: 20,
      fontWeight: 700,
    },
    /* This is for the text on intro screens, totally different style than other texts */
    h4: {
      fontFamily: 'Museo',
      fontSize: 22,
      fontWeight: 'bold',
      color: '#ffffff',
    },
    h5: {
      fontFamily: 'Museo',
      fontSize: 20,
      fontWeight: 'bold',
      lineHeight: 1.19,
      color: '#262626',
    },
    /* This is for the title on the Login page which is totally different then other titles */
    h6: {
      fontFamily: 'MuseoSans-500',
      fontSize: 30,
      lineHeight: 1.13,
      fontStretch: 'normal',
      fontStyle: 'normal',
      textAlign: 'left',
    },
    subtitle1: {
      fontFamily: 'MuseoSans',
      fontSize: 18,
      fontStretch: 'normal',
      fontStyle: 'italic',
      lineHeight: '1.22',
      textAlign: 'left',
      color: '#2a343f',
    },
    subtitle2: {
      fontFamily: 'MuseoSans',
      fontSize: '18px',
      fontWeight: 300,
      fontStretch: 'normal',
      fontStyle: 'italic',
      lineHeight: '1.22',
      textAlign: 'left',
      color: '#242424',
    },
    body1: {
      fontFamily: 'Museo',
      fontSize: 18,
      fontWeight: 500,
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1.22',
      textAlign: 'left',
      color: '#262626',
    },
    body2: {
      fontFamily: 'MuseoSans',
      fontSize: 18,
      fontWeight: 500,
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1.22',
      textAlign: 'left',
      color: '#ffffff',
    },
    body3: {
      fontFamily: 'MuseoSans',
      fontSize: '16px',
      fontWeight: '500',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1.25',
      letterSpacing: 'normal',
      textAlign: 'left',
    },
    caption: {
      fontFamily: 'MuseoSans',
      fontSize: '14',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'italic',
      lineHeight: 1.21,
    },
    button: {
      fontFamily: 'MuseoSans-500',
      fontSize: 17,
      fontWeight: 500,
    },
  },

  // https://material-ui.com/customization/palette/
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: colours.APP_PRIMARY,
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      main: colours.APP_SECONDARY,
    },
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: 3,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: 0.2,
    text: {
      primary: colours.APP_TEXT_PRIMARY,
      secondary: colours.APP_TEXT_SECONDARY,
    },
  },
  overrides: {
    MuiFormControlLabel: {
      label: {
        fontFamily: 'Lato-Regular',
        fontWeight: 'normal !important',
        fontSize: 16,
        lineHeight: '1.13 !important',
        wordBreak: 'break-word',
      },
    },
    MuiMobileStepper: {
      // customization options are defined in https://material-ui.com/api/mobile-stepper/#css
      root: {
        background: '#ffffff',
      },
      dotActive: {
        backgroundColor: colours.APP_PRIMARY,
      },
      dot: {
        margin: '10px',
        width: '10px',
        height: '10px',
      },
    },
    MuiBottomNavigationAction: {
      root: {
        color: NEVADA_GRAY,
        fontFamily: 'Museo',
        fontSize: '7px',
        fontWeight: 'bold',
        lineHeight: '1',
        border: '1px Solid #efefef',
        marginLeft: '0.5px',
        marginRight: '0.5px',
      },
    },
    MuiExpansionPanel: {
      root: {
        '&$expanded': {
          margin: 0,
        },
      },
      rounded: {
        borderRadius: 0,
        '&:first-child': {
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
        },
        '&:last-child': {
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
          // Fix a rendering issue on Edge
          '@supports (-ms-ime-align: auto)': {
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
          },
        },
      },
    },
  },
});

export { zcareTheme };
